import { adsExtensionDoubleListStyle, adExtensionItemTemplateStyles } from '@bingads-webui-campaign-react/common-styles';

export const adExtensionsStyles = ({ palette = {}, iconFontFamily = 'MsAds MDL2 Assets' }) => ({
  '& .container-fluid': {
    padding: 0,

    '& .adgroup-ads__container': {
      marginTop: 20,
      borderTop: `1px solid ${palette.neutralLight}`,
      width: '100%',
      minHeight: 133,
      '&.mixed-mode-campaign-creation': {
        minHeight: 'auto',

        '& h3': {
          lineHeight: 'inherit',
        },
      },

      '& .adgroup-display': {
        padding: 0,
        width: 160,
        marginRight: 37,
      },

      '& .adgroup-display-title': {
        fontSize: 18,
        color: palette.neutralPrimary,
        fontWeight: 600,

        '& span': {
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          display: 'inline-block',
          maxWidth: 160,
        },
      },

      '& .adgroup-display-keyword': {
        fontSize: 14,
        color: palette.neutralSecondary,

        '& span': {
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          display: 'inline-block',
          maxWidth: 160,
        },
      },
    },

    '& .adgroup-creative': {
      minHeight: 113,
      borderBottom: `1px solid ${palette.neutralLight}`,

      '& .adgroup-ads-creative>div:last-child': {
        minHeight: 133,
      },

      '& .adgroup-dashedBox-sm': {
        border: 0,
      },
    },

    '& .standard-adgroup-ad-creation-section-container, & .dynamic-adgroup-ad-creation-section-container': {
      '& h3 a': {
        clear: 'both',
        fontSize: 18,
        paddingLeft: 0,
        '&:hover': {
          textDecoration: 'none',
          backgroundColor: '#f3f2f1',
        },
      },
      '& .adgroup-ads-creative': {
        marginLeft: 30,
      },
    },

    '& .ads-creative': {
      marginTop: 10,
      marginBottom: 10,
      backgroundColor: palette.white,
      border: 0,
      paddingLeft: 0,

      '& .ad-editor-list-group': {
        zoom: 1,
        outline: 'none',

        '&:focus': {
          outline: `1px solid ${palette.neutralSecondary}`,
        },
      },

      '& .ad-editor-list-group:after': {
        clear: 'both',
        content: '""',
        display: 'block',
        height: 0,
        width: 0,
        visibility: 'hidden',
      },

      '& .ad-editor-list-group:focus': {
        '& .k-state-focused': {
          backgroundColor: palette.neutralLighter,
        },

        '& .k-state-selected': {
          backgroundColor: palette.neutralLight,
        },
      },

      '& .row': {
        top: 3,
        left: 500,

        '& .pager': {
          height: 'auto',
          width: '300px',
        },
        '& .pager:first-child span': {
          verticalAlign: 'baseline',
        },
      },
    },

    '& .adgroup-ads__container+.form-group': {
      marginTop: 9,
      marginLeft: 0,
      marginRight: 0,

      '& a': {
        fontSize: 18,
        fontWeight: 600,
      },
    },

    '& .expandedImage, .expanderImage': {
      marginRight: 11,
      marginBottom: 2,
    },


    '& .ad-extensions>p': {
      marginLeft: 0,
    },

    '& .ad-extensions>.form-group': {
      margin: '9px 0',
    },

    '& .ad-extensions': {

      borderBottom: `1px solid ${palette.neutralSecondary}`,
      marginBottom: 58,
      paddingBottom: 10,

      '& .text-right': {
        clear: 'both',
        width: 'auto',
        float: 'none',
        marginLeft: 30,
        padding: 0,
        textAlign: 'left', // Fix for bug 1953624
      },

      '& p': {
        color: palette.neutralPrimary,
        margin: '5px 0 0 30px',
      },

    },

    '& .create-ad': {
      background: palette.white,
      border: `1px solid ${palette.neutralSecondaryAlt}`,
      boxSizing: ' border-box',
      borderRadius: 2,
      height: 32,
      minWidth: 152,
      textAlign: 'center',
      lineHeight: '32px',
      marginTop: 45,
      marginBottom: 45,
      float: 'left',

      '& .create-ad-link': {
        color: '#323130',
        fontWeight: 600,
        display: 'block',
        width: '100%',
        height: '100%',
        position: 'relative',
        padding: '0 12px',

        '&:focus, &:active, &:hover': {
          textDecoration: 'none',
          border: 0,
        },

        '&:focus:after, &:active:after, &:hover:after': {
          border: `1px solid ${palette.neutralSecondary}`,
          outline: '1px solid transparent',
          position: 'absolute',
          top: 1,
          bottom: 1,
          left: 1,
          right: 1,
          content: '""',
        },
      },

      '& .glyphicon-plus': {
        marginRight: 12,
        verticalAlign: 'inherit',
      },
    },

    '& .adEditor-listitem': {
      background: palette.white,
      border: `1px solid ${palette.neutralSecondary}`,
      height: 110,
      width: 364,
      float: 'left',
      padding: 13,
      position: 'relative',
      marginRight: 113,
      marginBottom: 5,
      marginTop: 5,

      '& .previewTitleAd': {
        display: 'block',
      },

      '& .truncated': {
        height: '18px',
        lineHeight: '20px',
        display: 'block',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
      },

      '& .truncated:first-child': {
        height: '24px',
      },

      '& .truncated:first-child span': {
        fontSize: 20,
        color: '#001BA0',
        verticalAlign: 'top',
      },

      '& .preview-ad-slug': {
        verticalAlign: 'top',
      },

      '& a.previewUrlAd': {
        fontSize: 13,
        color: '#006D21',

        '& span': {
          verticalAlign: 'top',
        },
      },

      '& .previewtext': {
        fontSize: 13,
        color: '#666666',

        '& span': {
          verticalAlign: 'top',
        },
      },

      '& .adEditor-toolbar': {
        height: 24,
        position: 'absolute',
        right: 8,
        bottom: 3,

        '& .btn-group': {
          '&:after': {
            content: '"|"',
            color: palette.neutralPrimary,
          },

          '&:last-child:after': {
            content: '""',
          },
        },

        '& .btn': {
          minWidth: 'auto',
          height: 'auto',
          border: 'none',
          float: 'left',
          padding: '0 2px',
          backgroundColor: 'transparent',
          color: palette.themePrimary,
          fontWeight: 'normal',
        },

        '& .open > .dropdown-menu': {
          width: 'auto',

          '& .btn': {
            padding: '2px 10px',
            float: 'none',
            width: '100%',
            textAlign: 'left',
          },

          '& .copy-to-some': {
            paddingRight: 26,
            position: 'relative',

            '& .caret': {
              marginTop: 4,
              position: 'absolute',
              right: 0,
              marginRight: 10,
            },
          },

          '& .copyToSome': {
            '& label': {
              lineHeight: '24px',

              '& input': {
                marginRight: 0,
              },

              '& span': {
                width: 160,
                display: 'inline-block',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              },
            },

            '& li>a:focus::after': {
              display: 'none',
            },
          },
        },

      },

      '& .responsive-ad-preview-shared-template': {
        '& div': {
          color: '#767676',
        },

        '& img': {
          width: 114,
          height: 60,
          marginRight: 8,
        },
      },
    },

    '& .adEditor-error': {
      borderColor: '#A80000',
    },

    '& a[data-target="#createAdExtensions"]': {
      width: '100%',
      display: 'inline-block',

      '&:hover': {
        border: 'none',
        textDecoration: 'none',
        backgroundColor: '#F3F2F1',
      },

      '&:focus': {
        border: '1px solid',
        borderColor: palette.neutralSecondary,
        textDecoration: 'none',
        outline: 'none',
      },
    },

    ...adsExtensionDoubleListStyle({ palette, iconFontFamily }),
    ...adExtensionItemTemplateStyles()({ palette, iconFontFamily }),
  },
});
